var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 13C2.16667 13.4602 2.53977 13.8333 3 13.8333H9.66667C10.1269 13.8333 10.5 14.2064 10.5 14.6667C10.5 15.1269 10.1269 15.5 9.66667 15.5H3C1.61929 15.5 0.5 14.3807 0.5 13V3C0.5 1.61929 1.61929 0.5 3 0.5H9.66667C10.1269 0.5 10.5 0.8731 10.5 1.33333C10.5 1.79357 10.1269 2.16667 9.66667 2.16667H3C2.53977 2.16667 2.16667 2.53977 2.16667 3V13ZM5.5 8C5.5 7.53975 5.8731 7.16667 6.33333 7.16667H13.4882L12.4108 6.08926C12.0853 5.76382 12.0853 5.23618 12.4108 4.91074C12.7362 4.58531 13.2638 4.58531 13.5893 4.91074L16.0893 7.41075C16.4147 7.73617 16.4147 8.26383 16.0893 8.58925L13.5893 11.0892C13.2638 11.4147 12.7362 11.4147 12.4108 11.0892C12.0853 10.7638 12.0853 10.2362 12.4108 9.91075L13.4882 8.83333H6.33333C5.8731 8.83333 5.5 8.46025 5.5 8Z",
    fill: "#EEF9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.358669a8f7190ee2c0584f21394da7ad.svg";
export { ForwardRef as ReactComponent };